// extracted by mini-css-extract-plugin
module.exports = {"FileInput":"FileInput_FileInput__1P2SO","uploadButton":"FileInput_uploadButton__12T75","uploadInput":"FileInput_uploadInput__2ZNRf"};